import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-done me-8",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_title = _resolveComponent("modal-title")!
  const _component_modal_header = _resolveComponent("modal-header")!
  const _component_the_form_anamnesis = _resolveComponent("the-form-anamnesis")!
  const _component_modal_body = _resolveComponent("modal-body")!
  const _component_modal_footer = _resolveComponent("modal-footer")!
  const _component_v_modal = _resolveComponent("v-modal")!

  return (_openBlock(), _createBlock(_component_v_modal, {
    size: "xl",
    "class-name": "modal-fullscreen-lg-down",
    onKeypress: _withKeys(_withModifiers(_ctx.finalizeAnamnesis, ["prevent"]), ["enter"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_modal_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_modal_title, { as: "h4" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Responder anamnesis')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_modal_body, null, {
        default: _withCtx(() => [
          _createVNode(_component_the_form_anamnesis, {
            "form-version": _ctx.currentAnamnesis.version,
            "form-type": _ctx.currentAnamnesis.type,
            "form-structure": _ctx.currentAnamnesisStructure,
            onAlertsUpdated: _ctx.emitAlertsUpdatedEvent
          }, null, 8, ["form-version", "form-type", "form-structure", "onAlertsUpdated"])
        ]),
        _: 1
      }),
      _createVNode(_component_modal_footer, null, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-link-secondary me-24",
            "aria-label": _ctx.$t('Cancelar'),
            "data-bs-dismiss": "modal"
          }, _toDisplayString(_ctx.$t('Cancelar')), 9, _hoisted_1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary btn-sm",
            "aria-label": _ctx.$t('Finalizar'),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.anamnesisSuggest && _ctx.anamnesisSuggest(...args)))
          }, [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('Finalizar')), 1)
          ], 8, _hoisted_2)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onKeypress"]))
}